
import React, { Fragment, useRef, useState } from 'react'
import { Button, Col, FormGroup, FormLabel, Modal, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import useTranslation from '@/Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'

import { addDocument } from '@/Services/ProgrammationManagerService'
import { addDocumentAction } from '@/Redux/Actions/ProgrammationManagerActions'

import InputText from '../../components/InputText'

import AddICon from '../../../SvgImages/Add'

import './DocumentsUploader.scss'

interface UploadResponse {
  key: string;
  url?: string;
}

const DocumentsUploader = () => {

  const fileRef: any = useRef()

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, patchItemOpened } = useProgrammation()

  const [ showModal, setShowModal ] = useState(false)
  const [file, setFile] = useState<File | null>(null);
  const [ name, setName ] = useState('')
  const [preview, setPreview] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0];
    if (!selected) return;

    setFile(selected);
    setName(selected.name)

    // Para mostrar una vista previa si es imagen
    if (selected.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => setPreview(reader.result as string);
      reader.readAsDataURL(selected);
    } else {
      setPreview(null);
    }
  };

  const handleUpload = async () => {
    if (!file) return alert('Selecciona un archivo primero');

    setUploading(true);

    const [ error, data ] = await addDocument(itemOpened._id, file, name)

    setUploading(false);

    if (error) {
      return console.log(error)
    }

    patchItemOpened({
      documents: itemOpened.documents.concat(data.document)
    })

    dispatch(addDocumentAction(data.document))

    fileRef.current.value = ''

    setFile(null)
    setPreview(null)
    setShowModal(false)
  };


  const handleCancel = () => {
    setFile(null)
    setPreview(null)
    setShowModal(false)
  }

  return (
    <Fragment>
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className='mb-2'
      >
        <AddICon fill="#fff" height={24} width={24} />
      </Button>

      <Modal
        show={showModal}
        onHide={handleCancel}
        backdropClassName='documents-uploader-backdrop'
        className='documents-uploader'
      >
        <Modal.Header>
          <Modal.Title>
            {t('DOCUMENTS_UPLOADER:Title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <FormLabel>
              {t('DOCUMENTS_UPLOADER:FileLabel')}
            </FormLabel>
            <div>
              <input type="file" onChange={handleFileChange} ref={fileRef} />
            </div>
          </FormGroup>
          {file && (
            <Fragment>
              {preview && (
                <FormGroup>
                  <FormLabel>
                    {t('DOCUMENTS_UPLOADER:PreviewLabel')}
                  </FormLabel>
                  <div style={{ marginTop: '0.5rem', textAlign: 'center' }}>
                    <img src={preview} alt="preview" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                  </div>
                </FormGroup>
              )}
              <FormGroup>
                <FormLabel>
                  {t('DOCUMENTS_UPLOADER:NameLabel')}
                </FormLabel>
                <InputText
                  value={name}
                  onChange={setName}
                />
              </FormGroup>
              <FormGroup>
                <FormLabel>
                  {t('DOCUMENTS_UPLOADER:SizeLabel')}
                </FormLabel>
                <div>
                  {file.size}
                </div>
              </FormGroup>
              <FormGroup>
                <FormLabel>
                  {t('DOCUMENTS_UPLOADER:TypeLabel')}
                </FormLabel>
                <div>
                  {file.type}
                </div>
              </FormGroup>
            </Fragment>
          )}
          <Row>
            <Col style={{ textAlign: 'right' }}>
              <Button
                variant='primary'
                onClick={handleUpload}
                disabled={!file || uploading}
              >
                <AddICon fill="#fff" height={24} width={24} />{' '}
                {!uploading && t('DOCUMENTS_UPLOADER:UploadButton')}
                {uploading && t('DOCUMENTS_UPLOADER:UploadButtonUploading')}
              </Button>
            </Col>
          </Row>

          {/* {file && (
            <div style={{ marginTop: '1rem' }}>
              <p><strong>Nombre:</strong> {file.name}</p>
              <p><strong>Tamaño:</strong> {(file.size / 1024).toFixed(2)} KB</p>
              <p><strong>Tipo:</strong> {file.type}</p>

              {preview && (
                <div style={{ marginTop: '0.5rem' }}>
                  <img src={preview} alt="preview" style={{ maxWidth: '100%', height: 'auto' }} />
                </div>
              )}

              <button onClick={handleUpload} style={{ marginTop: '1rem' }}>
                Subir al servidor
              </button>
            </div>
          )} */}
        </Modal.Body>
      </Modal>
    </Fragment>
  )
}

export default DocumentsUploader
